import { render } from "./all-recommend.vue?vue&type=template&id=fc917abe&scoped=true"
import script from "./all-recommend.vue?vue&type=script&lang=js"
export * from "./all-recommend.vue?vue&type=script&lang=js"

import "./all-recommend.vue?vue&type=style&index=0&id=fc917abe&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc917abe"]])

export default __exports__